import {Collapse, Dropdown, Offcanvas} from 'bootstrap';
import {docReady} from './components/theme/events';
import {imageCarousel, slider, syncMultipleSliders, syncSlider, wpPostSlider} from './components/flickity/flickity.entrypoint';
import miniLightbox from './components/theme/mini-lightbox';
import thisYear from './components/theme/this-year';
import isScrolled from './components/theme/is-scrolled';
import scrollToItem from './components/theme/scroll-to-item';
import inView from './components/theme/in-view';
import makeBgImage from './components/theme/make-bg-image';
import fixedNavBodyPadding from './components/theme/fixed-nav-body-padding';
import {toggleActive} from './components/theme/toggle';
import wpAccordion from './components/accordion/wp-accordion';

docReady(() => {
   miniLightbox();
   fixedNavBodyPadding();
   thisYear();
   isScrolled();
   scrollToItem();
   inView();
   makeBgImage();
   slider();
   imageCarousel();
   syncMultipleSliders();
   wpPostSlider();
   toggleActive();
   wpAccordion();
})
